import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';
import { NavLink, UncontrolledTooltip as Tooltip } from 'reactstrap';
import { I18N } from 'commons';

const ItemTitle = ({ id, priority, title, index }) => (
  <h2>
    {priority && <i id={`icon_priority_${id}`} className="priority fas fa-exclamation-triangle" aria-hidden="true" />}
    {priority && (
      <Tooltip placement="top" target={`icon_priority_${id}`}>
        <I18N>notification.title.priority</I18N>
      </Tooltip>
    )}
    <NavLink
      id={`notificationTitle${id}`}
      eb-test="ee_notificationList_link_itemTitle"
      tag={({ ...props }) => (
        <Link to={`${id}`} {...props}>
          <span className="sr-only">{index + 1}&nbsp;</span>
          {title}
        </Link>
      )}
    />
  </h2>
);

ItemTitle.propTypes = {
  priority: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default ItemTitle;
